module.exports = __webpack_public_path__ + "static/media/skill-node.2b7bb0f9.png";